import ApisService from './index'
import { handleError } from '../utils/commonUtils'
import * as queryString from 'query-string'


export function getListCommonLog(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisService.get('/common/filter-log', {
      params: query || {},
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}
